import * as React from 'react';
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

type requestFormProps = {
    showNotPossibleIdentifyTrashes: boolean,
    setShowNotPossibleIdentifyTrashes: React.Dispatch<React.SetStateAction<boolean>>

};

export const NotPossibleIdentifyTrashes = ({
                                               showNotPossibleIdentifyTrashes,
                                               setShowNotPossibleIdentifyTrashes
                                           }: requestFormProps) => {
    const [open, setOpen] = React.useState(false);
    const [openAfter, setAfterOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
        setAfterOpen(false);
        setShowNotPossibleIdentifyTrashes(false);
    };

    React.useEffect(() => {
        if (showNotPossibleIdentifyTrashes) {
            setOpen(true);
        }
    }, [showNotPossibleIdentifyTrashes]);

    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                maxWidth={'md'}
            >
                <DialogTitle sx={{m: 0, p: 2, mr: 5}} id="customized-dialog-title">
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
                <DialogContent dividers>
                    Nepavyko tiksliai nustatyti atliekų kiekio. Įkelkite dar 1–2 nuotraukas iš kito kampo.
                </DialogContent>
            </BootstrapDialog>
        </>
    );
}
